import { PageId } from 'constants/pages'
import { WOOFZ_PAYMENT, WOOFZ_SUB_CNLD_70 } from 'root-constants'
import { useZustandSessionStore } from '../../zustandGlobalSessionStore'

export const getNextFlowPageIdAfterPayment = (): PageId => {
  const urlParams = new URLSearchParams(window.location.search)
  const currentCohort = urlParams.get('cohort')
  const { hasAccount, hasSubscription } = useZustandSessionStore.getState()

  if (currentCohort === WOOFZ_SUB_CNLD_70 && hasAccount && hasSubscription) {
    return PageId.DOWNLOAD
  }

  return currentCohort === WOOFZ_PAYMENT
    ? PageId.ACCOUNT_APP_TO_WEB
    : PageId.ACCOUNT_NOVE8
}
